import React from 'react'
import { observer } from 'mobx-react'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import DateInput from '../../input/date'
import SelectInput from '../../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import DateField from 'react-mobx-admin/components/common/field/date'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import EmbededEntityInput from '../../input/embedded_entity'
import RegionsInput from '../../input/regions'

const AmazonInfoEditTable = ({ store, updateField, ...rest }) => {
  const _AmazonInfoForm = ({ record, updateFormField, errors }) => (
    <div className='row'>
      <div className='col-xs-12'>
        <TextInput label={store.__('Asin ID')} attr={'asin_id'} record={record}
          onChange={updateFormField} errors={errors} />
        <TextInput label={store.__('Video ID')} attr={'video_platform_id'} record={record}
          onChange={updateFormField} errors={errors} />
        <TextInput label={store.__('title')} attr={'title'} record={record}
          onChange={updateFormField} errors={errors} />
        <SelectInput label={store.__('Category')}
          attr={'category'} record={record}
          onChange={updateFormField} optionsrecord={store.options} optionsattr={'AmazonCategories'}
          labelattr='text' valueattr='value' errors={errors} />
        <SelectInput label={store.__('Language')}
          attr={'language'} record={record}
          onChange={updateFormField} optionsrecord={store.options} optionsattr={'Languages'}
          labelattr='text' valueattr='value' errors={errors} />
        <RegionsInput label={store.__('Regions')} attr={'regions'}
          record={record} onChange={updateFormField} errors={errors}
          optionsrecord={store.options} optionsattr={'Countries'} />
        <TextInput label={store.__('note')} attr={'note'} record={record}
          onChange={updateFormField} errors={errors} />
        <DateInput label={store.__('published')} attr={'publish_date'} record={record}
          onChange={updateFormField} errors={errors} />
        <DateInput label={store.__('canceled')} attr={'cancel_date'} record={record}
          onChange={updateFormField} errors={errors} />
      </div>
    </div>
  )

  return (
    <div className='row'>
      <div className='col-xs-12 col-sm-12'>
        <EmbededEntityInput
          store={store}
          attr={'amazoninfo'}
          edit_title={store.__('edit Amazon ID record')}
          add_title={store.__('add Amazon ID record')}
          fields={[
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => (
              <OptionsField
                attr={attr}
                val={row[attr]}
                options={store.options.get('AmazonCategories')}
                labelattr='text'
                valueattr='value'
              />
            ),
            (attr, row) => (
              <OptionsField
                attr={attr}
                val={row[attr]}
                options={store.options.get('Languages')}
                labelattr='text'
                valueattr='value'
              />
            ),
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => (<DateField attr={attr} val={row[attr]} />),
            (attr, row) => (<DateField attr={attr} val={row[attr]} />)
          ]}
          rowId={(row) => null}
          EditForm={_AmazonInfoForm} {...rest}
        />
      </div>
    </div>
  )
}
export default observer(AmazonInfoEditTable)
